import React, { useEffect, useState } from "react";

import { ShieldHalf } from "lucide-react";

import {
  clearSimulatedAccess,
  simulatedAccess,
  simulatingMinutesLeft,
} from "@/util";
import { MASQUERADE_BAR_HEIGHT } from "@/NavBar/constants";

export const SimulatePermissionsBar: React.FC = () => {
  const sim = simulatedAccess();
  const [minutesLeft, setMinutesLeft] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setMinutesLeft(simulatingMinutesLeft() ?? 0);
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  if (!sim) {
    return null;
  }

  return (
    <div
      className="flex w-full justify-between bg-amber-500 p-1"
      style={{ height: `${MASQUERADE_BAR_HEIGHT}px` }}
    >
      <div className="flex items-center gap-2 text-sm text-white">
        <ShieldHalf size={20} />
        Simulating a restricted permission set
        {sim.backendOnly ? " on the backend only (UI unrestricted)" : ""}.{" "}
        {minutesLeft > 0 && `${minutesLeft} minutes left.`}
      </div>

      <button
        className="rounded-sm border border-white px-2 text-xs text-white uppercase hover:cursor-pointer hover:bg-white hover:text-black dark:hover:bg-gray-100"
        onClick={() => {
          clearSimulatedAccess();
          window.location.reload();
        }}
        title="Stop simulating"
      >
        Stop
      </button>
    </div>
  );
};
